module.exports = __webpack_public_path__ + "img/root1.cd0950ba.png";